export default "/kiban/_next/static/images/manufacture-e413bed600b551ade3fd48d26a71f9d3.png";